import './App.css';
import ShoppingCart from './components/ShoppingCart';

function App() {
  return (
    <div >
      <header className="App-header">
        <ShoppingCart></ShoppingCart>
      </header>
    </div>
  );
}

export default App;
